// import { PatientsApi } from "@/api/patients";

import UserState from "./constants";

interface ModuleContext {
  state: UserState;
  rootGetters: any;
  commit: any;
}

export default {
  // async getPatientProfile({ commit, rootGetters }: ModuleContext, payload: string) {
  //   try {
  //     const { uid } = rootGetters;
  //     const payloadId = payload || uid;
  //     const profile = await PatientsApi.patientGetProfile(payloadId);
  //     commit("setPatient", profile);
  //   } catch (err) {
  //     throw err;
  //   }
  // },
};
